import React from 'react';
import { Route, Switch } from 'react-router-dom';

import StartScreen from './containers/StartScreen';
import MainScreen from './containers/MainScreen';
import FinishScreen from './containers/FinishScreen';
import ErrorPaymentScreen from './containers/ErrorPaymentScreen';
import NotFoundScreen from './containers/NotFoundScreen';
import OrderScreen from "./containers/OrderScreen";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
  <Switch>
    <Route exact path="/" component={StartScreen}/>
    <Route path="/processing/:tariff?" component={MainScreen}/>
    <Route path="/order/:code" component={OrderScreen}/>
    <Route path="/finish" component={FinishScreen}/>
    <Route path="/error-payment" component={ErrorPaymentScreen}/>
    <Route component={NotFoundScreen}/>
  </Switch>
);